const slideDown = (type, speed, delay) => {
  const transition = { type: type, duration: speed };

  return {
    initial: {
      y: -100,
      opacity: 0,
      transition: { ...transition, delay: delay },
    },
    animate: { y: 0, opacity: 1, transition: { ...transition, delay: 0 } },
    exit: { y: -100, opacity: 0, transition: { ...transition, delay: 0 } },
  };
};
const slideUp = (type, speed, delay) => {
  const transition = { type: type, duration: speed };

  return {
    initial: {
      y: 100,
      opacity: 0,
      transition: { ...transition, delay: delay },
    },
    animate: { y: 0, opacity: 1, transition: { ...transition, delay: 0 } },
    exit: { y: 100, opacity: 0, transition: { ...transition, delay: 0 } },
  };
};
const slideInLeft = (type, speed, delay) => {
  const transition = { type: type, duration: speed };

  return {
    initial: {
      x: 300,
      opacity: 0,
      transition: { ...transition, delay: delay },
    },
    animate: { x: 0, opacity: 1, transition: { ...transition, delay: 0 } },
    exit: { x: 300, opacity: 0, transition: { ...transition, delay: 0 } },
  };
};
const fadeIn = (type, speed, delay) => {
  const transition = { type: type, duration: speed };

  return {
    initial: { opacity: 0, transition: { ...transition, delay: delay } },
    animate: { opacity: 1, transition: { ...transition, delay: 0 } },
    exit: { opacity: 0, transition: { ...transition, delay: 0 } },
  };
};
const rotate = (type, speed, delay) => {
  const transition = { type: type, duration: speed };

  return {
    initial: { rotate: 0, transition: { ...transition, delay: delay } },
    animate: { rotate: 360, transition: { ...transition, delay: 0 } },
    exit: { rotate: 0, transition: { ...transition, delay: 0 } },
  };
};
const logoEntry = (type, speed, delay) => {
  const transition = { type: type, duration: speed };

  return {
    initial: {
      x: "50%",
      y: "50%",
      scale: "300%",
      opacity: 0,
      transition: { ...transition, delay: 0 },
    },
    animate: {
      x: "0%",
      y: "0%",
      scale: "100%",
      opacity: 1,
      transition: { ...transition, delay: delay },
    },
    exit: { rotate: 0, transition: { ...transition, delay: 0 } },
  };
};

const animations = {
  slideDown: slideDown,
  slideUp: slideUp,
  fadeIn: fadeIn,
  rotate: rotate,
  slideInLeft: slideInLeft,
  logoEntry: logoEntry,
};

export { animations };
